import {useImageReset} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageReset';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

export const PhotoEditorHeader = ({canvas}) => {
  const {resetImage} = useImageReset(canvas);

  return (
    <div className="uyo-control-header">
      <Typography variant="label2" color="pebble">
        PHOTO EDITOR
      </Typography>
      <Button
        variant="link"
        size="small"
        onClick={resetImage}
        className="uyo-control-reset-button"
        data-qa-id="photo-editor-reset-all-btn"
      >
        <Typography variant="label2" color="tanzanite">
          Reset all
        </Typography>
      </Button>
    </div>
  );
};
